import React, { useState } from 'react';
import Navbar from '../components/Feed/FeedNavbar';
import LeftSidebar from '../components/Feed/LeftSidebar';
import RightSidebar from '../components/Feed/RightSidebar';
import MainFeed from '../components/Feed/MainFeed';
import BottomNavbar from '../utils/unifiedBottom';
import SearchBar from '../components/globals/SearchBar';
import { useMediaQuery } from '../hooks/useMediaQuery';

const Explore = () => {
  const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);

  // Check if screen is at least 1280px (Tailwind's 'xl' breakpoint)
  const isDesktop = useMediaQuery('(min-width: 1280px)');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navigation */}
      <Navbar
        isRightSidebarOpen={isRightSidebarOpen}
        setIsRightSidebarOpen={setIsRightSidebarOpen}
      />

      {/* Main Layout */}
      <div className="pt-4 lg:pt-20 flex justify-center max-w-7xl mx-auto gap-4 lg:gap-4 xl:gap-6 px-4 lg:px-6">

        {/* Left Sidebar: Fixed at w-64, hidden on mobile */}
        <LeftSidebar isRightSidebarOpen={isRightSidebarOpen} />
        {/* Explore Content Area */}
        <div className="flex-1 min-w-0 w-full lg:max-w-[650px] xl:max-w-none">
          <div className="flex flex-col gap-4">
            <SearchBar searchApi={`/api/profile/search`} />
            <MainFeed isExplore={true} />
          </div>
        </div>

        {/* Right Sidebar: 
            Logic: Only mount if isDesktop is true. 
            This prevents the component from executing the useSuggestedUsers hook on mobile.
        */}
        {isDesktop && (
          <div className="w-80 flex-shrink-0">
            <RightSidebar isVisible={isDesktop} />
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      <div className="lg:hidden">
        <BottomNavbar />
      </div>
    </div>
  );
};

export default Explore;